export const login = {
	en: {
		singular: 'login',
		plural: 'login'
	},
	ar: ''
}

export const preview = {
	en: {
		singular: 'preview',
		plural: 'preview'
	},
	ar: ''
}

export const dashboard = {
	en: {
		singular: 'dashboard',
		plural: 'dashboard'
	},
	ar: ''
}

export const sets = {
	en: {
		singular: 'set',
		plural: 'sets'
	},
	ar: ''
}

export const categories = {
	en: {
		singular: 'category',
		plural: 'categories'
	},
	ar: ''
}

export const category = {
	en: {
		singular: 'category',
		plural: 'categories'
	},
	ar: ''
}
export const filters = {
	en: {
		singular: 'filter',
		plural: 'filters'
	},
	ar: ''
}
export const keywords = {
	en: {
		singular: 'keyword',
		plural: 'keywords'
	},
	ar: ''
}

export const products = {
	en: {
		singular: 'product',
		plural: 'products'
	},
	ar: ''
}

export const product = {
	en: {
		singular: 'product',
		plural: 'products'
	},
	ar: ''
}
export const news = {
	en: {
		singular: 'event',
		plural: 'events'
	},
	ar: ''
}

export const newsIndex = {
	en: {
		singular: 'event',
		plural: 'events'
	},
	ar: ''
}

export const orders = {
	en: {
		singular: 'order',
		plural: 'orders'
	},
	ar: ''
}

export const order = {
	en: {
		singular: 'order',
		plural: 'orders'
	},
	ar: ''
}

export const albums = {
	en: {
		singular: 'album',
		plural: 'gallery'
	},
	ar: ''
}

export const sliders = {
	en: {
		singular: 'slider',
		plural: 'sliders'
	},
	ar: ''
}

export const users = {
	en: {
		singular: 'user',
		plural: 'users'
	},
	ar: ''
}

export const subscriptions = {
	en: {
		singular: 'subscription',
		plural: 'subscriptions'
	},
	ar: ''
}

export const aboutUs = {
	en: {
		singular: 'about us',
		plural: 'about us',
	},
	ar: ''
}

export const SEO = {
	en: {
		singular: 'SEO',
		plural: 'SEO',
	},
	ar: ''
}